import {deepPurple, teal, yellow} from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';


const customTheme = createMuiTheme({
    typography: {
        letterSpacing: 10,
        fontFamily: [                        
            '微軟正黑體',
            'Arial',
            'sans-serif'
        ].join(','),      
    },
    palette: {
        primary: {
            main: deepPurple[200],
        },
        secondary: {
            main: yellow[50],
        },
    },
});

export default customTheme
